export const EMAIL_POSTAL_CODE_LOGIN_INITIATE =
  'EMAIL_POSTAL_CODE_LOGIN_INITIATE';
import { EmailPostalCodePayload } from '@src/app/login/types';

export type Actions = {
  EMAIL_POSTAL_CODE_LOGIN_INITIATE: {
    type: typeof EMAIL_POSTAL_CODE_LOGIN_INITIATE;
    payload: { email: string; postalCode: string };
  };
};

export const actionCreators = {
  emailPostalCodeLogin: (
    payload: EmailPostalCodePayload,
  ): Actions[typeof EMAIL_POSTAL_CODE_LOGIN_INITIATE] => ({
    type: EMAIL_POSTAL_CODE_LOGIN_INITIATE,
    payload,
  }),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/login/weak/emailpostalcode/actions.ts